<script setup lang="ts">
import { useId } from 'vue';

defineProps<{
  group: 'children' | 'adults';
}>();

const maskId = useId();
</script>

<template>
  <svg
    v-if="group === 'children'"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    aria-hidden="true"
  >
    <circle cx="15" cy="15" r="14.5" fill="white" stroke="#E0E0E0" />
    <mask
      :id="maskId"
      style="mask-type: luminance"
      maskUnits="userSpaceOnUse"
      x="3"
      y="5"
      width="24"
      height="20"
    >
      <path
        d="M25.6504 24.4004V5.59961H4.34961V24.4004H25.6504Z"
        fill="white"
        stroke="white"
        stroke-width="1.2"
      />
    </mask>
    <g :mask="`url(#${maskId})`">
      <path
        d="M10.293 16.0898C10.293 15.3471 10.8951 14.745 11.6379 14.745C12.3806 14.745 12.9827 15.3471 12.9827 16.0898"
        stroke="#FF8B2F"
        stroke-width="1.2"
        stroke-miterlimit="10"
      />
      <path
        d="M17.0176 16.0898C17.0176 15.3471 17.6197 14.745 18.3624 14.745C19.1052 14.745 19.7073 15.3471 19.7073 16.0898"
        stroke="#FF8B2F"
        stroke-width="1.2"
        stroke-miterlimit="10"
      />
      <path
        d="M12.6816 18.7796C13.1495 19.5724 14.012 20.1047 14.9993 20.1047C15.9865 20.1047 16.849 19.5724 17.3169 18.7796"
        stroke="#FF8B2F"
        stroke-width="1.2"
        stroke-miterlimit="10"
      />
      <path
        d="M24.4141 15.8554C24.4141 16.9562 23.5324 17.8511 22.4363 17.8718C21.5504 21.148 18.5566 23.5586 15 23.5586C11.4434 23.5586 8.44961 21.148 7.56367 17.8718C6.46758 17.8511 5.58594 16.9562 5.58594 15.8554C5.58594 15.2984 5.81172 14.7941 6.17656 14.4289C6.5332 14.0726 7.02227 13.8492 7.56367 13.839C8.44961 10.5629 11.4434 8.15231 15 8.15231C18.5566 8.15231 21.5504 10.5629 22.4363 13.839C22.9777 13.8492 23.4668 14.0726 23.8234 14.4289C24.1883 14.7941 24.4141 15.2984 24.4141 15.8554Z"
        stroke="#FF8B2F"
        stroke-width="1.2"
        stroke-miterlimit="10"
      />
      <path
        d="M12.4936 10.6591C12.4936 12.0435 13.6159 13.1657 15.0003 13.1657C16.3847 13.1657 17.507 12.0435 17.507 10.6591C17.507 9.27465 16.3847 8.15238 15.0003 8.15238H14.6074C13.3389 8.15238 12.3105 7.12402 12.3105 5.85547"
        stroke="#FF8B2F"
        stroke-width="1.2"
        stroke-miterlimit="10"
      />
      <path
        d="M14.9996 8.15234H11.917C10.6484 8.15234 9.62012 7.12398 9.62012 5.85547"
        stroke="#FF8B2F"
        stroke-width="1.2"
        stroke-miterlimit="10"
      />
    </g>
  </svg>

  <svg
    v-else
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    aria-hidden="true"
  >
    <circle cx="15" cy="15" r="14.5" fill="white" stroke="#E0E0E0" />
    <path
      d="M15.254 19.895V23.9365C15.254 24.5238 14.7779 25 14.1905 25C13.6031 25 13.127 24.5238 13.127 23.9365V19.895"
      stroke="#BB71B8"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.3253 8.04768C17.5952 6.90441 16.8873 5.75875 15.744 5.4888C14.6007 5.21884 13.4551 5.9268 13.1851 7.07007C12.9151 8.21334 13.6231 9.359 14.7664 9.62896C15.9096 9.89892 17.0553 9.19095 17.3253 8.04768Z"
      stroke="#BB71B8"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.1271 13.0883V16.2789C13.1271 16.8663 12.6509 17.3425 12.0635 17.3425C11.4762 17.3425 11 16.8663 11 16.2789V11.8121C11 10.6373 11.9523 9.68498 13.1271 9.68498H17.3813C18.556 9.68498 19.5083 10.6373 19.5083 11.8121V16.279C19.5083 16.8663 19.0322 17.3425 18.4448 17.3425C17.8574 17.3425 17.3813 16.8664 17.3813 16.279V13.0883"
      stroke="#BB71B8"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.2549 19.895V23.9365C15.2549 24.5238 15.7311 25 16.3184 25C16.9058 25 17.382 24.5238 17.382 23.9365V19.895"
      stroke="#BB71B8"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.9085 17.1974L18.6573 19.895H11.8506L12.5993 17.1974"
      stroke="#BB71B8"
      stroke-width="1.2"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
